"use client";
import {
  useHovercardHeading
} from "../__chunks/6MFI6SZM.js";
import "../__chunks/6DEDXFNU.js";
import "../__chunks/TIW3GMFC.js";
import "../__chunks/44L5375W.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-heading.tsx
var TagName = "h1";
var useMenuHeading = createHook(
  function useMenuHeading2(props) {
    props = useHovercardHeading(props);
    return props;
  }
);
var MenuHeading = forwardRef(function MenuHeading2(props) {
  const htmlProps = useMenuHeading(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuHeading,
  useMenuHeading
};
